export default __webpack_public_path__ + "static/media/README.4d8bd024.md";